import { DEFAULT_LOCALES } from "@faire/web/common/consts/DEFAULT_LOCALES";
import { THREE_TO_TWO_LETTER_LANGUAGE_CODE } from "@faire/web/common/consts/THREE_TO_TWO_LETTER_LANGUAGE_CODE";

export const getRandomLocale = () => {
  const availableLocales = Object.keys(DEFAULT_LOCALES);
  const random = Math.floor(Math.random() * availableLocales.length);
  // @ts-expect-error FIXME(implicitAny): https://faire.link/no-implicit-any
  return THREE_TO_TWO_LETTER_LANGUAGE_CODE[availableLocales[random]!];
};
